import { createReducer } from '@reduxjs/toolkit';
import type { ILottery } from 'types/ILottery';
import { fetchLotteries, fetchLottery } from 'store/actions/lotteryActions';

export enum LoadingStatus {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  REJECTED = 'REJECTED',
}

export interface LotteryState {
  lotteries: ILottery[];
  selectedLottery: ILottery | null;
  loading: LoadingStatus;
  error: string | null;
}

const initialState: LotteryState = {
  lotteries: [],
  selectedLottery: null,
  loading: LoadingStatus.IDLE,
  error: null,
};

const lotteryReducer = createReducer<LotteryState>(initialState, (builder) => {
  builder
    .addCase(fetchLotteries.pending, (state) => {
      state.loading = LoadingStatus.PENDING;
      state.error = null;
    })
    .addCase(fetchLotteries.fulfilled, (state, action) => {
      state.loading = LoadingStatus.FULFILLED;
      state.lotteries = action.payload;
    })
    .addCase(fetchLotteries.rejected, (state, action) => {
      state.loading = LoadingStatus.REJECTED;
      state.error = action.payload?.message || 'Fehler beim Laden der Lotterien';
    })
    .addCase(fetchLottery.fulfilled, (state, action) => {
      state.selectedLottery = action.payload;
    });
});

export default lotteryReducer;
